import { render, staticRenderFns } from "./Block4Creation.vue?vue&type=template&id=489e032b&scoped=true&"
import script from "./Block4Creation.vue?vue&type=script&lang=js&"
export * from "./Block4Creation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489e032b",
  null
  
)

export default component.exports